export default "__VITE_ASSET__BIDKQYpJ__"